import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import { AddMfaBackup } from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class AddBackupMfaService {
  addBackupMfaHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.setupMfa+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  addBackupMfa = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<AddMfaBackup> => {
    const getAddBackupMfaUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const addBackupMfaUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getAddBackupMfaUrl
      }
    ];

    return new ApiBuilder<undefined, AddMfaBackup>(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(addBackupMfaUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.addBackupMfaHeader)
      .errorHandler(this._errorHandler)
      .library('ADD_MFA_BACKUP_SERVICE')
      .withCredentials(true)
      .create();
  };
}
